
import Layout from "../../../components/layout";
import LogoSlider from "../../../components/logo-slider";
import PageHeading from "../../../components/page-header";

import fs from 'fs';
import path from 'path';

export async function getStaticProps() {
  const dir = path.join(process.cwd(), 'public/images/companies');
  const files = fs.readdirSync(dir);
  const logos = files.map((file) => `/images/companies/${file}`);

  return {
    props: { logos },
  };
}


export default function System( { logos }) {

  return (
      <Layout>
        <PageHeading heading_text='System Integration' image_url={'/images/heroslider/system_integration.webp'}/>

        <div className="section white-bg">
          <div className="container">
          <div className="row g-5 justify-content-center align-items-center">
            <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">EVERY DEVICE. ONE SYSTEM. COMPLETE CONTROL.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12">
                        <h5 className="section-title">SMART CONNECTIONS. TOTAL CONTROL.</h5>
                        <p className="section-description">We make it all work together — seamlessly.
At Proslv, our system integration solutions connect your AV, lighting, networking, and control systems into one cohesive platform. Whether it’s a corporate environment or a large-scale venue, we eliminate complexity and deliver reliable, unified performance that just works — every time.
                           <br/> <br/>
                          Proslv integration — engineered for simplicity and scale.
                        </p>
                </div>
            </div>
          </div>
        </div>

        <div className="section black-bg client-section">

    <LogoSlider logos={logos}/>

    <div className="section-separator"></div>

    
  </div>

      </Layout>
  );
}
